// @ts-ignore
import React from "react";

import { css } from "@compiled/react";

import { ContentBlock } from "@/components/wpl/content-block/src";
import { PictureProps } from "@/components/wpl/image/src";
import { Row } from "@/libraries/wpl/foundations/src";
import { IconNameTypes } from "@/libraries/wpl/foundations/src";

const workflowSectionStyle = css({
    "paddingBlockStart": "16px",
    "paddingBlockEnd": "64px",
    ".text-section": {
        padding: "16px"
    },
    ".img-section": {
        order: 1,
        padding: "16px"
    }
});

export type WorkflowSectionProps = {
    readonly iconName?: IconNameTypes;
    readonly iconColor?: string;
    readonly headerText: string;
    readonly bodyText: string;
    readonly pictureImg: PictureProps;
};

const WorkflowSection = ({
    iconName,
    iconColor,
    headerText,
    bodyText,
    pictureImg
}: WorkflowSectionProps) => {
    return (
        <section className="workflow-container" css={workflowSectionStyle}>
            <Row>
                <ContentBlock
                    className="tabs-quote-header-content-block"
                    iconName={iconName || "checkmarkcircle"}
                    iconColor={iconColor || "#091e42"}
                    headerText={headerText}
                    headerType="h3"
                    bodyText={bodyText}
                    isCentered={true}
                    pictureProps={pictureImg}
                />
            </Row>
        </section>
    );
};

export default WorkflowSection;
